import { AfterViewInit, Component } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DialogTitle } from "../../template/dialog-template.component";
import { DialogComponent } from "../dialog.component";

export interface ThumbnailEnlargeDialogData {
  source?: string;
  canvas?: HTMLCanvasElement;
  title: DialogTitle;
}

@Component({
  selector: "app-thumbnail-enlarge-dialog",
  imports: [MatProgressSpinnerModule],
  templateUrl: "./thumbnail-enlarge-dialog.component.html",
  styleUrl: "./thumbnail-enlarge-dialog.component.less",
})
export class ThumbnailEnlargeDialogComponent extends DialogComponent<ThumbnailEnlargeDialogData> implements AfterViewInit {
  public source: string | null;
  public loaded: boolean;

  public constructor() {
    super();
    this.source = null;
    this.loaded = false;
  }

  public ngAfterViewInit(): void {
    if (this.data) {
      this.source = this.data.source ?? this.data.canvas?.toDataURL() ?? null;
    }
  }
}
